import ActiveComponentRouter from '@/componentRouter.active';

const API_URL = process.env.API_URL || 'http://localhost:3000';

/**
 *
 * @param $urlRouterProvider
 * @param $stateProvider
 */
export default function stateProviderConfig(
  $urlRouterProvider,
  $stateProvider
){

  'ngInject';

  $urlRouterProvider
    .when('/', '/booking')
    .when(/^\/confirm-booking\/(.+)$/, function($match) {
      window.location.href = `${API_URL}/confirm-booking/` + $match[1];
    });

  $stateProvider
    .state(ActiveComponentRouter('forbidden'))
    .state(ActiveComponentRouter('unauthorized'))
    .state(ActiveComponentRouter('notfound'))
    .state(ActiveComponentRouter('signin'))
    .state(ActiveComponentRouter('password/:token'))
    .state({
        name: 'adminBooking',
        url: '/admin/booking',
        template: '<admin-booking-component></admin-booking-component>'
      })

}


/** WEBPACK FOOTER **
 ** ./frontend/config/stateProvider.config.js
 **/